import { useBaseDelivery } from '@features/delivery';
import { useRecentEmails } from '@features/delivery/hooks/useRecentEmails';
import { useCallback } from 'react';
import { ShareableItem, ShareDeliveryItem, SharePayload } from '../types';
import { useShareAction } from './useShareAction';

export const useShareModal = () => {
    const { executeShare } = useShareAction();
    const { recentEmails, addEmailsToHistory } = useRecentEmails();

    const { openModal, deliveryState, deliveryActions } = useBaseDelivery<
        ShareDeliveryItem,
        SharePayload
    >({
        apiAction: async (items, payload) => {
            return await executeShare(items, payload);
        },
        onSuccess: (payload) => {
            if (payload.emails.length > 0) {
                addEmailsToHistory(payload.emails);
            }
        },
    });

    const openShare = useCallback(
        (items: ShareableItem[]) => {
            openModal(
                items.map((item) => ({ ...item, isValid: item.hasProxy })),
            );
        },
        [openModal],
    );

    return {
        openShare,
        dialogProps: {
            ...deliveryState,
            ...deliveryActions,
            onOpenChange: deliveryActions.setIsOpen,
            suggestedEmails: recentEmails,
        },
    };
};
